import {createStack} from '@famly/mf_layout_stack';

/**
 * ModalFooterButtons component
 *
 * A container for modal footer buttons that handles responsive layout.
 * On mobile devices, buttons are stacked vertically.
 * On tablet and larger screens, buttons are arranged horizontally.
 *
 * Should be used inside a ModalFooter component.
 *
 * @example
 * <ModalFooter>
 *   <ModalFooterButtons>
 *     <ModalDeleteButton onClick={handleDelete} />
 *     <ModalSecondaryButton text="Cancel" onClick={handleCancel} />
 *     <ModalPrimaryButton text="Save" onClick={handleSave} />
 *   </ModalFooterButtons>
 * </ModalFooter>
 */
export const ModalFooterButtons = createStack({
    flexDirection: {
        base: 'column',
        tabletPortrait: 'row',
    },
    width: '100%',
    gap: 2,
});
